interface StatsCardProps {
  title: string;
  value: string | number;
  icon: string;
  color: 'primary' | 'blue' | 'purple' | 'green';
}

const colorClasses = {
  primary: 'from-primary-600 to-primary-700',
  blue: 'from-blue-600 to-blue-700',
  purple: 'from-purple-600 to-purple-700',
  green: 'from-green-600 to-green-700',
};

export default function StatsCard({ title, value, icon, color }: StatsCardProps) {
  return (
    <div className="card relative overflow-hidden">
      <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${colorClasses[color]} opacity-10 rounded-full -mr-8 -mt-8`}></div>
      <div className="relative">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-400 mb-1">{title}</p>
            <p className="text-2xl font-bold text-white">{value}</p>
          </div>
          <span className="text-3xl">{icon}</span>
        </div>
      </div>
    </div>
  );
}
